import { render, staticRenderFns } from "./ApiTokenCreateDialog.vue?vue&type=template&id=ff82e3c4"
import script from "./ApiTokenCreateDialog.vue?vue&type=script&lang=js"
export * from "./ApiTokenCreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports